import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import Styles from './vm-icon.scss';

@customElement('vm-icon')
export class VmIcon extends LitElement {
    static override styles = Styles;

    @property()
    name: string;

    override render() {
        return html`<i class="icon icon-${this.name}"></i>`;
    }
}
